/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


// (function() {

//   // Below are example event listeners.  They listen for theme events that Pipeline
//   // fires in order to make it easier for you to add customizations.

//   // Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.


//   document.addEventListener('theme:variant:change', function(event) {
//     // You might use something like this to write a pre-order feature or a
//     // custom swatch feature.
//     var variant = event.detail.variant;
//     var container = event.target;
//     if (variant) {
//       console.log('Container ———————— ↓');
//       console.log(container);
//       console.log('Variant —————————— ↓');
//       console.log(variant);
//       // ... update some element on the page
//     }
//   });

//   document.addEventListener('theme:cart:change', function(event) {
//     var cart = event.detail.cart;
//     if (cart) {
//       console.log('Cart ———————————— ↓');
//       console.log(cart);
//       // ... update an app or a custom shipping caluclator
//     }
//   });
//   // Fired when page loads to update header values
//   document.addEventListener('theme:cart:init', (e) => {
//     console.log('theme:cart:init');
//     console.log(e);
//   });

//   // Debounced scroll listeners.  Up and down only fire on direction changes
//   // These events are useful for creating sticky elements and popups.
//   document.addEventListener('theme:scroll', e => { console.log(e); });
//   document.addEventListener('theme:scroll:up', e => { console.log(e); });
//   document.addEventListener('theme:scroll:down', e => { console.log(e); });

//   // Debounced resize listener to bundle changes that trigger document reflow
//   document.addEventListener('theme:resize', e => { console.log(e); });

//   // Locks and unlocks page scroll for modals and drawers
//   // These are commented out because firing them will lock the page scroll
//   // the lock event must set `detail` to the modal or drawer body so the 
//   // scroll locking code knows what element should maintain scoll. 
//   // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
//   // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


//   // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.
// })();

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.pro-agotado').forEach(function(el) {
    el.parentNode.removeChild(el);
  });  
});

function getTags(proID) {
  const productElement = document.querySelector(`.item-${proID}`);
  const proUrl = productElement?.dataset.link;

  if (proUrl) {
    fetch(proUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const tagOriginElement = doc.querySelector('.tagOrigin');
        const tagsHtml = tagOriginElement ? tagOriginElement.innerHTML : '';

        const targetElement = document.querySelector(`.item-${proID} .card__media .tags51`);
        if (targetElement) {
          targetElement.innerHTML = tagsHtml;
        }
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
      });
  }

  // Check and call normalInfo() outside of the fetch block
  // to ensure it runs regardless of the network request success.
  if (typeof normalInfo === 'function') {
    normalInfo();
  }
}

function getTagsAll() {
  const allProducts = document.querySelectorAll('[data-proid]');
  allProducts.forEach(product => {
    const proID = product.getAttribute('data-proid');
    getTags(proID);
  });
}

// Initial function calls
if (typeof normalInfo === 'function') {
  normalInfo();
}
if (typeof getTagsAll === 'function') {
  getTagsAll();
}

(function () {
  // --- util: debounce para evitar explosión de llamadas ---
  function debounce(fn, delay) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), delay);
    };
  }

  // --- envoltorio seguro para rebind ---
  const rebindAll = debounce(function () {
    if (typeof normalInfo === 'function') {
      try { normalInfo(); } catch (e) { console.warn('normalInfo() error', e); }
    }
    if (typeof getTagsAll === 'function') {
      try { getTagsAll(); } catch (e) { console.warn('getTagsAll() error', e); }
    }
  }, 120);

  const _origGetTagsAll = (typeof getTagsAll === 'function') ? getTagsAll : null;
  if (_origGetTagsAll) {
    window.getTagsAll = function () {
      const nodes = document.querySelectorAll('[data-proid]:not([data-tags-loaded])');
      nodes.forEach(n => {
        const proID = n.getAttribute('data-proid');
        if (proID && typeof getTags === 'function') {
          getTags(proID);
          // marca como procesado para no repetir
          n.setAttribute('data-tags-loaded', '1');
        }
      });
    };
  }

  // --- observar cambios en la grilla ---
  function setupGridObserver() {
    const container = document.querySelector('.collection__products');
    if (!container) return;

    // Observador: solo reaccionamos si hay nodos relevantes añadidos/eliminados
    const observer = new MutationObserver((mutations) => {
      let changed = false;
      for (const m of mutations) {
        if (m.type !== 'childList') continue;

        if (m.addedNodes && m.addedNodes.length) {
          for (const n of m.addedNodes) {
            if (n.nodeType !== 1) continue;
            if (
              n.matches?.('[data-proid], product-grid-item, .product-grid-item') ||
              n.querySelector?.('[data-proid], product-grid-item, .product-grid-item')
            ) { changed = true; break; }
          }
        }
        if (changed) break;

        if (m.removedNodes && m.removedNodes.length) {
          // si se removieron items, probablemente se reinyectarán otros
          changed = true; break;
        }
      }
      if (changed) rebindAll();
    });

    observer.observe(container, { childList: true, subtree: true });

    // expón por si quieres apagarlo en algún flujo
    window.__collectionProductsObserver = observer;
  }

  // --- dispara en los momentos típicos de Broadcast / Shopify ---
  document.addEventListener('DOMContentLoaded', function () {
    // run inicial
    if (typeof normalInfo === 'function') normalInfo();
    if (typeof getTagsAll === 'function') getTagsAll();

    setupGridObserver();
  });

  // Cuando se recargan secciones vía AJAX (filtros, sort, etc.)
  document.addEventListener('shopify:section:load', rebindAll);
  document.addEventListener('shopify:section:reorder', rebindAll);


})();

(function() {
  const OPEN_DELAY_MS = 2500; 
  function openCartDrawer() {
    const opener = document.querySelector('[data-drawer-toggle="drawer-cart"]');
    if (opener) {
      if (window.theme?.state?.cartOpen) return;
      opener.click();
    }
  }

  let timer = null;
  function scheduleOpen() {
    clearTimeout(timer);
    timer = setTimeout(openCartDrawer, OPEN_DELAY_MS);
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    scheduleOpen();
  });
})();